import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get Pending Named Drink Requests
export const getPendingDrinkRequests = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get/pending/drink/requests", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        message: "...",
        data: [
          {
            id,
            user_id,
            drink_name,
            drink_name_en,
            drink_id,
            status: "pending",
            notes,
            created_at,
            updated_at,
            drink: {...}
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get All Named Drink Requests
export const getDrinkRequests = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/admin/get/drink/requests", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    return res.data;
    /*
      expected:
      {
        message: "تم جلب الطلبات بنجاح",
        data: [
          {
            id,
            user_id,
            drink_name,
            drink_name_en,
            drink_id,
            status, // pending/approved/rejected...
            notes,
            created_at,
            updated_at,
            drink: {...}
          }
        ]
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Get Drink Request Details
export const getDrinkRequestDetails = async (requestId) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get(
      `/admin/get/drink/request/details/${requestId}`,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    const data = res.data?.data;

    // 🔥 parse ingredients لو راجعة string
    if (data?.drink?.ingredients && typeof data.drink.ingredients === "string") {
      data.drink.ingredients = JSON.parse(data.drink.ingredients);
    }

    return res.data;
    /*
      expected:
      {
        message: "...",
        data: {
          id,
          user_id,
          drink_name,
          status,
          notes,
          drink: {
            ingredients: []
          }
        }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Update Drink Request Status (pending | approved | rejected)
export const updateDrinkRequestStatus = async (requestId, status) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
    // لا تضيف Content-Type هنا مع FormData (axios يضبطه تلقائيًا)
  };

  try {
    const formData = new FormData();
    formData.append("status", status);

    const res = await api.post(
      `/admin/update/drink/request/status/${requestId}`,
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        message: "تم تحديث حالة الطلب بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Delete Drink Requests (bulk)
export const deleteDrinkRequests = async (ids = []) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  try {
    const res = await api.post(
      "/admin/delete/drink/requests",
      { ids }, // raw JSON body
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        message: "تم حذف الطلبات بنجاح"
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};